import type React from 'react';

import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { PRE_OCCUPANCY_AGREEMENT } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const INITIAL_STATE = {
  [PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.IS_ENABLED]: false,
  [PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.PROJECT_DESCRIPTION]: '',
};

export default function PreOccupancyAgreement({ section, setSectionValues }: Props): JSX.Element {
  function onNoAgreedWork(): void {
    setSectionValues(INITIAL_STATE);
  }

  function onYesAgreedWork(): void {
    setSectionValues({
      [PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onProjectDescription(event: React.FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({ [PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.PROJECT_DESCRIPTION]: value });
  }

  return (
    <FormField
      label={<Label size="lg">Have you agreed to do any work on the property before the tenant moves in?</Label>}
      control={
        <YesAndNoExpansion
          yesHandler={onYesAgreedWork}
          noHandler={onNoAgreedWork}
          yesActive={section.getFieldValue(PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.IS_ENABLED)}
        >
          <FormField
            label={<Label id="project-description">Describe the projects to be done</Label>}
            control={
              <Textarea
                aria-labelledby="project-description"
                placeholder="(example: Replace the carpet and apply a fresh coat of paint.)"
                onChange={onProjectDescription}
                value={section.getFieldValue(PRE_OCCUPANCY_AGREEMENT.FIELD_NAME.PROJECT_DESCRIPTION)}
                resize="vertical"
              />
            }
            description={<FormHelp>Limited to 2,000 characters</FormHelp>}
          />
        </YesAndNoExpansion>
      }
    />
  );
}
